import { InputAdornment } from '@material-ui/core'
import NumericInput from 'src/components/Formik/Forms/NumericInput'

interface Props {
  name: string
  label?: string
  isRestrictedEdit?: boolean
}

export const AliquotaIcmsInput = ({
  name,
  isRestrictedEdit = false,
  label = 'Alíquota ICMS'
}: Props) => {
  return (
    <NumericInput
      name={name}
      label={label}
      maxValue={100}
      disabled={isRestrictedEdit}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>
      }}
    />
  )
}
